import { useEffect, useState } from "react";
import { ApplicationLoadingDisplay } from "./ApplicationLoadingDisplay";

export function SSRWrapper({
  children,
  nullLoadingDisplay = false,
}: {
  children: React.ReactNode;
  nullLoadingDisplay?: boolean;
}) {
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    setIsInitialLoad(false);
  }, []);

  if (isInitialLoad) {
    if (nullLoadingDisplay) {
      return null;
    }
    return <ApplicationLoadingDisplay />;
  }
  return <>{children}</>;
}
